import React from "react";
import { useGLTF } from "@react-three/drei";



export function Sikkim(props) {
  const { nodes, materials } = useGLTF("/model.glb");
  const scale = 2; 

  

  return (
    <group {...props} dispose={null} scale={[scale, scale, scale]}>
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Mesh1.geometry}
        material={materials.defaultMat}
      >

      <meshStandardMaterial
          color="#ffffff"// Adjust the color to match the mountain
          roughness={0.75} 
          metalness={0.1}
          emissive="#000000"
          emissiveIntensity={0.1}
          
        />

      </mesh>
      {/* Sea start */}
      <mesh
        position={[-10, -20, -10]} // Adjust the position vertically
        receiveShadow
      >
        <planeGeometry args={[40, 40]} />
        <meshStandardMaterial color="#0080ff" transparent opacity={0.5} />
      </mesh>
      {/* Sea end */}
    </group>
  );
}

useGLTF.preload("/model.glb");

export default Sikkim;